import React from 'react';
import { Music2 } from 'lucide-react';

const AnthemSection = () => {
    return (
        <section className="bg-white py-20 px-4 max-w-6xl mx-auto">
            <div className="text-center mb-12">
                <h1
                    className="text-4xl md:text-5xl font-bold text-gray-800 flex justify-center items-center gap-2"
                    data-aos="fade-down"
                >
                    <Music2 className="text-blue-500 w-8 h-8" />
                    Ibadan South Diocese Anthem
                </h1>
                <hr
                    className="w-28 border-t-2 border-blue-500 mx-auto mt-3"
                    data-aos="fade-down"
                    data-aos-delay="100"
                />
            </div>

            {/* English Version */}
            <div
                className="bg-gray-50 shadow-lg rounded-lg p-8 mb-12"
                data-aos="fade-up"
                data-aos-delay="150"
            >
                <h2 className="text-2xl font-bold text-red-600 text-center mb-6">
                    English Version
                </h2>

                <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                    <p>
                        <strong>1.</strong> Let us worship the Lord, the redeemed of the Lord; <br />
                        Let us praise the Lord, the purchased by the blood; <br />
                        Let us sing to God, who joy belongs, <br />
                        <strong>Ibadan South Diocese</strong> shout Halle-luyah.
                    </p>

                    <p>
                        <strong>2.</strong> The spring of joy, the anointed of the Lord, <br />
                        The fountain of life, the believer of His word; <br />
                        The city set on the hill, cannot be hid; <br />
                        <strong>Ibadan South Diocese</strong> shout Halle-luyah.
                    </p>

                    <div className="text-center text-yellow-600 font-bold mt-6">Refrain:</div>
                    <p>
                        The joy of the Lord we bring, praise to JESUS we ring; <br />
                        For the joy of the Lord is our strength, Shout for joy, shout for joy <br />
                        For the Living God is the One we serve, Shout for joy, shout for joy <br />
                        <strong>Ibadan South Diocese</strong> shout Halle-luyah.
                    </p>

                    <div className="text-center text-red-600 font-bold mt-6">
                        End of Stanza 2 <br />
                        Halleluiah Halleluiah Halleluiah Halleluiah <br />
                        Halleluiah Halleluiah Halleluiah
                    </div>
                </div>
            </div>

            {/* Yoruba Version */}
            <div
                className="bg-gray-50 shadow-lg rounded-lg p-8"
                data-aos="fade-up"
                data-aos-delay="250"
            >
                <h2 className="text-2xl font-bold text-red-600 text-center mb-6">
                    Yoruba Version
                </h2>

                <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                    <p>
                        <strong>1.</strong> Jẹ́ ká sin Olúwa, ẹ̀yin tá a rà padà; <br />
                        Jẹ́ ká yìn Olúwa, ẹ̀yin tá fẹ́jẹ̀ rà; <br />
                        K'orin s'Olorun, Ìjọ aláyọ; <br />
                        <strong>Ibadan South Diocese</strong> ké Halẹlúyà.
                    </p>

                    <p>
                        <strong>2.</strong> Orísun ayọ̀, ẹni oróró Olúwa; <br />
                        Orísun ìyẹ, ẹni tó gbà ọ̀rọ̀ Rẹ̀ gbọ́; <br />
                        Ìlú tá tẹ̀ dó sórí òkè, kò le fárasí; <br />
                        <strong>Ibadan South Diocese</strong> ké Halẹlúyà.
                    </p>

                    <div className="text-center text-yellow-600 font-bold mt-6">Ègbé:</div>
                    <p>
                        Ayọ̀ Ọlọ́run là mú wá, Ìyìn sí JESU là ńkede <br />
                        Ayọ̀ Ọlọ́run ni agbára wa, Hó f'ayọ̀, Hó f'ayọ̀ <br />
                        Ọlọ́run Alààyè ni àwa ńsin, Hó f'ayọ̀, Hó f'ayọ̀ <br />
                        <strong>Ibadan South Diocese</strong> ké Halẹlúyà.
                    </p>

                    <div className="text-center text-red-600 font-bold mt-6">
                        Lẹ́hìn ẹsẹ̀ kejì <br />
                        Halẹlúyà Halẹlúyà Halẹlúyà Halẹlúyà <br />
                        Halẹlúyà Halẹlúyà Halẹlúyà
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AnthemSection;
